/* eslint-disable default-case */
/* eslint-disable no-console */
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

// eslint-disable-next-line import/no-extraneous-dependencies
// import { LogLevel } from "@azure/msal-browser";
import { OpenIDConnect } from '../../../config/constant'
/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
    auth: {
        clientId: OpenIDConnect.ClientID, // "219ebab5-8064-4ca1-a189-e852e3eb104c", // This is the ONLY mandatory field that you need to supply.
        authority: OpenIDConnect.URL, // "https://login.microsoftonline.com/organizations", // Defaults to "https://login.microsoftonline.com/common"
        redirectUri: OpenIDConnect.API_Redirect, // "http://localhost:3000", // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {

    },
}

export const msalConfigBo = {
    auth: {
        clientId: OpenIDConnect.ClientID, // "219ebab5-8064-4ca1-a189-e852e3eb104c", // This is the ONLY mandatory field that you need to supply.
        authority: OpenIDConnect.URL, // "https://login.microsoftonline.com/organizations", // Defaults to "https://login.microsoftonline.com/common"
        redirectUri: OpenIDConnect.API_Redirect_BO,
        // redirectUri: window.location.pathname?.includes('/bo/auth')
        //     ? OpenIDConnect.API_Redirect_BO
        //     : OpenIDConnect.API_Redirect,
        // "http://localhost:3000", // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
        postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
        navigateToLoginRequestUrl: false, // If "true", will navigate back to the original request location before processing the auth code response.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {

    },
}
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ['User.Read'],
}

/**
 * An optional silentRequest object can be used to achieve silent SSO
 * between applications by providing a "login_hint" property.
 */
export const silentRequest = {
    scopes: ['openid', 'profile'],
    loginHint: 'example@domain.net',
}

// Add Okta config object
export const oktaConfig = {
    issuer: 'https://amaurygroupe.okta.com',
    clientId: '0oar1ohjjw046t8sq697',
    redirectUri: `${window.location.origin}/login/callback`,
    scopes: ['openid', 'profile', 'email'],
}
